const style = {
    toolTipBorder: {
        backgroundColor: "background.second",
        padding: "8px",
        borderRadius: "5px",
    }
}

export default style;